import { render, staticRenderFns } from "./OneComission.vue?vue&type=template&id=6f4bc429"
import script from "./OneComission.vue?vue&type=script&lang=js"
export * from "./OneComission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports